export default "__VITE_PUBLIC_ASSET__3b0b23af__"